// extracted by mini-css-extract-plugin
module.exports = {"container":"number__container___KvG-l","percent":"number__percent___qz2QQ"};